import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";

// MUI
import { makeStyles } from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";
import Typography from "@material-ui/core/Typography";

import { get } from "../../db";
import { Grid, TextField } from "@material-ui/core";

const ProductDropdown = ({ category, onChange, error }) => {
  const [categories, setCategories] = useState([]);

  useEffect(() => {
    get(setCategories, "productCategories");
  }, []);

  return (
    <div>
      <Grid container>
        <Grid item md={12}>
          <form>
            <TextField
              select
              variant="outlined"
              fullWidth
              label="Category"
              required
              value={category}
              onChange={onChange}
              error={error ? true : false}
            >
              {categories.map((category, key) => (
                <MenuItem key={key} value={category._id}>
                  {category.name}
                </MenuItem>
              ))}
            </TextField>
          </form>
        </Grid>
      </Grid>

      {error && (
        <Typography variant="caption" color="error">
          {error}
        </Typography>
      )}
    </div>
  );
};

ProductDropdown.propTypes = {
  category: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  error: PropTypes.string,
};

export default React.memo(ProductDropdown);
